import { getLogger } from '../../diagnostics/logger';
import { combineReducers } from 'redux';
import boltOnReducer from './boltOnReducer';
import bundleTopupReducer from './bundleTopupReducer';
import excludedProvisioningDaysReducer from './excludedProvisioningDaysReducer';
import tariffReducer from './tariffReducer';
import temporalBoltOnReducer from './temporalBoltOnReducer';

const simProvisionReducer = combineReducers({
  boltOns: boltOnReducer,
  temporalBoltOns: temporalBoltOnReducer,
  bundleTopupSizes: bundleTopupReducer,
  tariffs: tariffReducer,
  excludedProvisioningDays: excludedProvisioningDaysReducer,
});

export default simProvisionReducer;
